import { useLocation } from "react-router-dom";
import { parseLangPrefix } from "@/components/LangSync";

/**
 * Returns the current language prefix for URL construction.
 * When user is on /fr/* → prefix "/fr". On /pt/* → "/pt". Otherwise "".
 *
 * Usage:
 *   const withLang = useLangPath();
 *   <Link to={withLang("/contact")}>…</Link>
 */
export function useLangPath() {
  const location = useLocation();
  const { lang } = parseLangPrefix(location.pathname);
  const prefix = lang && lang !== "en" ? `/${lang}` : "";
  return (path) => {
    if (!path) return prefix || "/";
    if (!path.startsWith("/")) return path;
    // Avoid double prefixing if caller accidentally passes /fr/..
    const { lang: embedded, rest } = parseLangPrefix(path);
    const clean = embedded ? rest : path;
    return prefix + (clean === "/" ? "" : clean) || "/";
  };
}
